/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Footer_Link_FaqInputs */

const en_home_footer_link_faq = /** @type {(inputs: Home_Footer_Link_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

const fr_home_footer_link_faq = /** @type {(inputs: Home_Footer_Link_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {Home_Footer_Link_FaqInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_footer_link_faq = /** @type {((inputs?: Home_Footer_Link_FaqInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Footer_Link_FaqInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_footer_link_faq(inputs)
	return fr_home_footer_link_faq(inputs)
});